<template>
  <div class="list">
    <div class="list-filter">
      <el-form :inline="true" :model="queryEntity" class="demo-form-inline">
        <el-form-item label="编码">
          <el-input size="medium" v-model="queryEntity.code" placeholder="编码" clearable></el-input>
        </el-form-item>
        <el-form-item label="名称">
          <el-input size="medium" v-model="queryEntity.name" placeholder="名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="导航栏">
          <el-select size="medium" clearable v-model="queryEntity.nav">
            <el-option label="是" :value="true" />
            <el-option label="否" :value="false" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="list-btn-select" size="small" type="primary" @click="selectList">查询</el-button>
          <el-button class="list-btn-reset" size="small" @click="resetSelect">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="list-tool cf">
      <div class="fl">
        <el-button class="list-btn" size="small" type="primary" :disabled="disableAuth('add')" @click="add">新增</el-button>
        <el-button class="list-btn" size="small" type="danger" :disabled="disableAuth('delete')" @click="deleteList">批量删除</el-button>
      </div>
      <div class="fr">
        <el-button class="list-btn" size="small" type="primary" @click="fullStaticize">全站静态化</el-button>
        <el-button class="list-btn" size="small" type="primary" @click="staticize">静态化</el-button>
        <el-button class="list-btn" size="small" type="success" @click="dynamic">动态化</el-button>
      </div>
    </div>
    <div class="list-table">
      <el-table ref="table" row-key="id" lazy :data="dataList" default-expand-all :tree-props="{children: 'childCategorys'}" :header-cell-class-name="headerCellClass" :max-height="tableHeight" stripe @selection-change="handleSelectionChange" size="medium" @sort-change='sortChange' :default-sort="{ prop: 'sortNo', order: 'descending' }">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="name" label="名称" width="300"> </el-table-column>
        <el-table-column prop="code" label="编码" width="120"> </el-table-column>
        <el-table-column prop="id" label="ID" width="80"> </el-table-column>
        <el-table-column prop="parentCategory.name" label="父栏目" width="120"> </el-table-column>
        <el-table-column prop="stateName" label="状态" width="100"> </el-table-column>
        <el-table-column prop="staticizeName" label="静态化" width="100"> </el-table-column>
        <el-table-column prop="navName" label="导航栏" width="100"> </el-table-column>
        <el-table-column prop="sortNo" label="排序号" sortable="custom" width="200"> </el-table-column>
        <el-table-column prop="remark" label="备注"> </el-table-column>
        <el-table-column fixed="right" label="操作" width="320">
          <template #default="scope">
            <el-button type="primary" size="mini" :disabled="disableAuth('add')" @click="addChild(scope)">增加子栏目</el-button>
            <el-button type="primary" size="mini" :disabled="disableAuth('view')" @click="view(scope)">查看</el-button>
            <el-button type="success" size="mini" :disabled="disableAuth('modify')" @click="modify(scope)">修改</el-button>
            <el-button type="danger" size="mini" :disabled="disableAuth('delete')" @click="deleteItem(scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script lang="ts">
import { Category } from "@/script/apps/cms/entity/CmsEntity";
import bus from "@/script/core/util/Bus";
import { Options } from "vue-class-component";
import { BaseList } from "@/script/core/view/BaseList";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { CategoryService } from "@/script/apps/cms/service/CategoryService";
import { MenuData } from "@/script/core/base/MenuData";
import { ElLoading, ElMessage } from "element-plus";

@Options({})
export default class CategoryList extends BaseList {
  private queryEntity: Category = {};

  private dataList: Category[] = [];

  private service = new CategoryService();

  public initData(): ServiceContext {
    this.queryParam.pager = {
      pageIndex: 1,
      pageSize: 1000,
      total: 0,
      sorters: [{ prop: "sortNo", sortField: "cc.sort_no", sortMode: "desc" }],
    };
    return ServiceFactory.build(
      "biz_cms_category",
      "/cms/category",
      "/cms/category",
      this.service
    );
  }

  public initQueryEntity() {
    this.queryEntity = {
      code: "",
      name: "",
    };
    return this.queryEntity;
  }

  addChild(scope: any) {
    const id = scope.row.id;
    this.$router.push({
      path: this.serviceContext.detailUrl,
      query: { id: 0, type: "A", cache: "0", parentId: id },
    });
    const menuData: MenuData = {
      name: String(this.serviceContext.listUrl),
      path: String(this.serviceContext.detailUrl),
      query: { type: "A", cache: "1" },
      isClose: true,
    };
    bus.emit("to-detail", menuData);
  }

  public afterLoadList(data: any): void {
    const dataList: Category[] = data.list as Category[];
    dataList.forEach((item) => {
      item.staticizeName = item.staticize ? "启用" : "禁用";
      item.navName = item.nav ? "是" : "否";
    });

    const dataTree: Category[] = [];
    dataList.forEach((item) => {
      if (!item.parentId) {
        item.childCategorys = [];
        dataTree.push(item);
        this.generateTree(dataList, item);
      }
    });
    this.dataList = dataTree;
  }

  private generateTree(dataList: Category[], parent: Category) {
    const childs: Category[] = [];
    dataList.forEach((item) => {
      if (item.parentId === parent.id) {
        childs.push(item);
        // 递归
        this.generateTree(dataList, item);
      }
    });
    if (childs.length > 0) {
      parent.childCategorys = childs;
    }
  }

  private fullStaticize() {
    const loading = ElLoading.service({
      lock: true,
      text: "全站静态化执行中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    this.service.fullStaticize().then(
      (result: any) => {
        loading.close();
        ElMessage({ type: "success", message: result.message });
        this.loadList();
      },
      (error: Error) => {
        loading.close();
        ElMessage.error("全站静态化失败，失败原因：" + error.message);
      }
    );
  }

  private staticize() {
    if (this.selectedList.length === 0) {
      ElMessage.error("请选择要静态化的栏目！");
      return;
    }
    const ids: number[] = [];
    this.selectedList.forEach((item) => {
      ids.push(item.id!);
    });

    const loading = ElLoading.service({
      lock: true,
      text: "静态化执行中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    this.service.staticize(ids).then(
      (result: any) => {
        (this.$refs.table as any).clearSelection();
        loading.close();
        ElMessage({ type: "success", message: result.message });
        this.loadList();
      },
      (error: Error) => {
        loading.close();
        ElMessage.error("静态化失败，失败原因：" + error.message);
      }
    );
  }

  private dynamic() {
    if (this.selectedList.length === 0) {
      ElMessage.error("请选择要动态化的栏目！");
      return;
    }
    const ids: number[] = [];
    this.selectedList.forEach((item) => {
      ids.push(item.id!);
    });

    const loading = ElLoading.service({
      lock: true,
      text: "动态化执行中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    this.service.dynamic(ids).then(
      (result: any) => {
        this.selectedList = [];
        loading.close();
        ElMessage({ type: "success", message: result.message });
        this.loadList();
      },
      (error: Error) => {
        loading.close();
        ElMessage.error("动态化失败，失败原因：" + error.message);
      }
    );
  }
}
</script>


<style lang="scss">
.el-table .expanded .el-table_1_column_2 .cell {
  padding-left: 20px;
}

.el-table [class*="el-table__row--level"] .el-table__expand-icon {
  margin-left: -20px;
  margin-right: 0px !important;
  padding-right: 6px;
}
</style>
